/** @jsxImportSource @emotion/react */
import React, { useCallback } from 'react';
import { jsx, css } from '@emotion/react';
import PageHeader from '@atlaskit/page-header';
import Button, { ButtonGroup } from '@atlaskit/button';
import Drawer from '@atlaskit/drawer';
import styled from '@emotion/styled';
import CustomerForm from '../CustomerForm';
import { Customer } from '../types';
import { queryCache, useMutation } from 'react-query';
import { BankAccount } from '../../bank/types';
import api from '../../../libs/api';
import { FormattedMessage } from 'components/i18n';
import { DrawerBody, DrawerContainer, DrawerFooter, DrawerHeader } from '../../../components/drawer';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  onSave: (customer: Customer) => void;
  customer: Customer;
}

const saveCustomer = async (customer: Customer) => api.put('/Customers', customer);

const CustomerEditDrawer: React.FC<Props> = ({isOpen, onCancel, onSave, customer}) => {

  const [save, { status, isLoading: isSaving }] = useMutation(saveCustomer, {
    onSuccess: (savedCustomer: Customer) => {
      queryCache.invalidateQueries('customers');
      queryCache.invalidateQueries(['customer', savedCustomer.id])
      onSave(savedCustomer);
    }
    });

  const handleSave = useCallback(() => {
    // document.getElementById('customerForm')?.dispatchEvent(new Event('submit', { cancelable: true }))
    document.getElementById('customerForm')?.click();
  },[]);

  return (
    <Drawer
      onClose={onCancel}
      // onCloseComplete={this.onCloseComplete}
      // onOpenComplete={this.onOpenComplete}
      isOpen={isOpen}
      width="wide"
      overrides={{
        Content: {
          // hack to show shadow box overflow from CompanyAutosuggest
          cssFn: (defaultStyles) => ({...defaultStyles,
            paddingLeft: '4rem',
            marginLeft: '-4rem'
          })
        },
        Sidebar: {
          cssFn: (defaultStyles) => ({...defaultStyles, zIndex: 2})
        }
      }}
    >
      {isOpen && <DrawerContainer>
        <DrawerHeader>
          <PageHeader>{customer?.isNew? <FormattedMessage
            id='sale.CustomerEditDrawer.title.new'
            defaultMessage='New customer'
          /> : customer?.name}</PageHeader>
        </DrawerHeader>
        <DrawerBody>
          <CustomerForm initialValues={customer} onSubmit={save}/>
        </DrawerBody>
        <DrawerFooter>
          <div
            css={css`
              display: flex;
              justify-content: flex-end;
            `}
          >
            <ButtonGroup>
              <Button appearance="primary"
                      isLoading={isSaving}
                      onClick={handleSave}><FormattedMessage id="common.save" defaultMessage="Save"/></Button>
              <Button appearance="subtle" onClick={onCancel}><FormattedMessage id="common.cancel" defaultMessage="Cancel"/></Button>
            </ButtonGroup>
          </div>
        </DrawerFooter>
      </DrawerContainer> }
    </Drawer>
  );
};

export default CustomerEditDrawer;
